"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var render = function render(_c, _vm) {
  var _vm$props$m$getAvatar, _vm$props$message$use, _vm$props$message$use2, _vm$props$message$use3, _vm$props$m$getAvatar2, _context;
  return _c('div', {
    staticClass: "kiwi-messagelist-message kiwi-messagelist-message--modern",
    class: [_vm.props.m().isRepeat() ? 'kiwi-messagelist-message--authorrepeat' : 'kiwi-messagelist-message--authorfirst', 'kiwi-messagelist-message-' + _vm.props.message.type, _vm.props.message.type_extra ? 'kiwi-messagelist-message-' + _vm.props.message.type + '-' + _vm.props.message.type_extra : '', _vm.props.ml.isMessageHighlight(_vm.props.message) ? 'kiwi-messagelist-message--highlight' : '', _vm.props.ml.isHoveringOverMessage(_vm.props.message) ? 'kiwi-messagelist-message--hover' : '', _vm.props.ml.buffer.last_read && _vm.props.message.time > _vm.props.ml.buffer.last_read ? 'kiwi-messagelist-message--unread' : '', _vm.props.message.nick.toLowerCase() === _vm.props.ml.ourNick.toLowerCase() ? 'kiwi-messagelist-message--own' : '', _vm.props.ml.message_info_open === _vm.props.message ? 'kiwi-messagelist-message--info-open' : '', _vm.props.ml.message_info_open && _vm.props.ml.message_info_open !== _vm.props.message ? 'kiwi-messagelist-message--blur' : '', _vm.props.message.user && _vm.props.m().userMode(_vm.props.message.user) ? 'kiwi-messagelist-message--user-mode-' + _vm.props.m().userMode(_vm.props.message.user) : '', _vm.data.staticClass],
    attrs: {
      "data-message-id": _vm.props.message.id,
      "data-nick": (_vm.props.message.nick || '').toLowerCase()
    },
    on: {
      "click": function click($event) {
        return _vm.props.ml.onMessageClick($event, _vm.props.message, true);
      },
      "dblclick": function dblclick($event) {
        return _vm.props.ml.onMessageDblClick($event, _vm.props.message);
      }
    }
  }, [_c('div', {
    staticClass: "kiwi-messagelist-modern-left"
  }, [_vm.props.m().displayAvatar(_vm.props.message) ? void 0 : _vm._e()], 2), _c('div', {
    staticClass: "kiwi-messagelist-modern-right"
  }, [(_vm$props$m$getAvatar = _vm.props.m().getAvatar(_vm.props.message.nick)) !== null && _vm$props$m$getAvatar !== void 0 && _vm$props$m$getAvatar.small && _vm.props.m().isMessage(_vm.props.message) && !_vm.props.m().isRepeat() ? _c('div', {
    staticClass: "kiwi-messagelist-avatar",
    class: {
      'kiwi-messagelist-avatar--asl': _vm.props.m().getGender((_vm$props$message$use = _vm.props.message.user) === null || _vm$props$message$use === void 0 ? void 0 : _vm$props$message$use.realname) || _vm.props.m().getAge((_vm$props$message$use2 = _vm.props.message.user) === null || _vm$props$message$use2 === void 0 ? void 0 : _vm$props$message$use2.realname) || _vm.props.m().getProvince((_vm$props$message$use3 = _vm.props.message.user) === null || _vm$props$message$use3 === void 0 ? void 0 : _vm$props$message$use3.realname),
      'kiwi-messagelist-avatar--story': _vm.props.m().hasActiveStory(_vm.props.message.nick)
    },
    staticStyle: {
      "float": "left",
      "margin-right": "5px",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm$props$m$getAvatar2 = _vm.props.m().getAvatar(_vm.props.message.nick)) === null || _vm$props$m$getAvatar2 === void 0 ? void 0 : _vm$props$m$getAvatar2.small,
      "width": "40",
      "height": "40",
      "alt": "Avatar di ".concat(_vm.props.message.nick)
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "kiwi-messagelist-top"
  }, [_vm.props.message.nick ? _c('a', {
    class: ['kiwi-messagelist-nick', _vm.props.message.user && _vm.props.m().userMode(_vm.props.message.user) ? 'kiwi-messagelist-nick--mode-' + _vm.props.m().userMode(_vm.props.message.user) : ''],
    style: {
      'color': _vm.props.ml.userColour(_vm.props.message.user)
    },
    attrs: {
      "data-nick": _vm.props.message.nick.toLowerCase()
    },
    on: {
      "mouseover": function mouseover($event) {
        _vm.props.ml.hover_nick = _vm.props.message.nick.toLowerCase();
      },
      "mouseout": function mouseout($event) {
        _vm.props.ml.hover_nick = '';
      }
    }
  }, [_c('span', {
    staticClass: "kiwi-messagelist-nick-prefix"
  }, [_vm._v(_vm._s(_vm.props.message.user ? _vm.props.m().userModePrefix(_vm.props.message.user) : ''))]), _vm._v(_vm._s(_vm.props.message.nick) + " "), _vm.props && _vm.props.message.user && _vm.props.message.user.is_new ? _c('span', [_vm._v(" 🤗")]) : _vm._e(), _vm.props && _vm.props.message.user && _vm.props.message.user.is_monkey ? _c('span', [_vm._v(" 🐒")]) : _vm._e(), _vm.props && _vm.props.message.user && _vm.props.message.user.is_birthday ? _c('span', [_vm._v(" 🎂")]) : _vm._e(), _vm.props && _vm.props.message.user && _vm.props.message.user.is_winner ? _c('span', [_vm._v(" 🏆")]) : _vm._e(), _vm.props && _vm.props.message.user && _vm.props.message.user.has_emoji ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.props.message.user.emoji)
    }
  }) : _vm._e(), _vm.props && _vm.props.message.user && _vm.props.message.user.badge ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.props.message.user.badge)
    }
  }) : _vm._e(), _vm.props && _vm.props.message.user && _vm.props.message.user.is_bot ? _c('span', {
    staticClass: "kiwi-messagelist-bot-symbol"
  }, [_vm._v(" 🤖")]) : _vm._e(), _vm.props && _vm.props.message.user && _vm.props.message.user.account && !_vm.props.message.user.is_bot ? _c('span', {
    staticClass: "kiwi-messagelist-registered-symbol"
  }, [_vm._v(" REG")]) : _vm._e(), _vm.props && _vm.props.message.user && _vm.props.message.user.is_contributor ? _c('span', {
    staticClass: "kiwi-messagelist-contributor-symbol"
  }, [_vm._v(" 🌟")]) : _vm._e(), _vm.props && _vm.props.message.user && _vm.props.message.user.is_pro ? _c('span', {
    staticClass: "kiwi-messagelist-pro-symbol"
  }, [_vm._v(" PRO")]) : _vm._e()]) : _vm._e(), _vm.props.m().showRealName() ? _c('div', {
    staticClass: "kiwi-messagelist-realname",
    on: {
      "click": function click($event) {
        return _vm.props.ml.openUserBox(_vm.props.message.nick);
      },
      "mouseover": function mouseover($event) {
        _vm.props.ml.hover_nick = _vm.props.message.nick.toLowerCase();
      },
      "mouseout": function mouseout($event) {
        _vm.props.ml.hover_nick = '';
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.props.message.user.realname) + " ")]) : _vm._e(), _vm.props.m().isMessage(_vm.props.message) && _vm.props.ml.bufferSetting('show_timestamps') ? _c('div', {
    staticClass: "kiwi-messagelist-time",
    attrs: {
      "title": _vm.props.ml.formatTimeFull(_vm.props.message.time)
    }
  }, [_vm._v(" " + _vm._s(_vm.props.ml.formatTime(_vm.props.message.time)) + " ")]) : _vm._e()]), _vm.props.message.bodyTemplate && _vm.props.message.bodyTemplate.$el && _vm.props.ml.isTemplateVue(_vm.props.message.bodyTemplate) ? _c('div', {
    directives: [{
      name: "rawElement",
      rawName: "v-rawElement",
      value: _vm.props.message.bodyTemplate.$el,
      expression: "props.message.bodyTemplate.$el"
    }],
    staticClass: "kiwi-messagelist-body"
  }) : _vm.props.message.bodyTemplate ? _c(_vm.props.message.bodyTemplate, _vm._b({
    tag: "component",
    staticClass: "kiwi-messagelist-body",
    attrs: {
      "buffer": _vm.props.ml.buffer,
      "message": _vm.props.message,
      "idx": _vm.props.idx,
      "ml": _vm.props.ml
    }
  }, 'component', _vm.props.message.bodyTemplateProps, false)) : !(0, _includes.default)(_context = _vm.props.message.html).call(_context, '*, *, ey') ? _c('div', {
    staticClass: "kiwi-messagelist-body",
    domProps: {
      "innerHTML": _vm._s(_vm.props.ml.formatMessage(_vm.props.message))
    }
  }) : _vm._e(), _vm.props.ml.message_info_open === _vm.props.message ? _c(_vm.injections.components.MessageInfo, {
    tag: "component",
    attrs: {
      "message": _vm.props.message,
      "buffer": _vm.props.ml.buffer
    },
    on: {
      "close": function close($event) {
        return _vm.props.ml.toggleMessageInfo();
      }
    }
  }) : _vm._e(), _vm.props.message.embed.payload && _vm.props.ml.shouldAutoEmbed ? _c('div', [_c(_vm.injections.components.MediaViewer, {
    tag: "component",
    attrs: {
      "url": _vm.props.message.embed.payload,
      "show-pin": true
    },
    on: {
      "close": function close($event) {
        _vm.props.message.embed.payload = '';
      },
      "pin": function pin($event) {
        return _vm.props.ml.openEmbedInPreview(_vm.props.message);
      }
    }
  })], 1) : _vm._e()], 1)]);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;